// src/utils/axiosConfig.ts
import axios from "axios";
import Cookies from "cookies-js"; // Using cookies-js


const getCurrentPort = () => {
  if (typeof window !== 'undefined') {
    return window.location.port || '443';
  }
  return '5010';
};

// Set the base URL for all requests
const baseURL = "https://api.soc.iq"; // Replace with your API base URL

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL,
});

// Add an interceptor to include the Authorization header with each request
axiosInstance.interceptors.request.use(
  (config) => {
    const token = Cookies.get("authToken") // or get the token from cookies or state
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
